/**
 * @param scope passed into a renderer by JSONForms in form of #/properties/<blockName>
 * @returns name of the block
 */
export const getBlockNameByScope = (
  scope: string | undefined
): string | undefined => {
  return scope?.split('/').pop()
}
